import { defineRule } from 'vee-validate'
import zipCode from '@/data/validations/zipCodeValidation.json'
import { i18n } from '@/i18n.js'

defineRule('zip_code', (value, country) => {
  if (!value || value === '') {
    return true
  }

  if (country?.[0]) {
    if (!zipCode[country[0]]) {
      return i18n.global.t('form.wrongZipCode')
    }
    const re = new RegExp(`^${zipCode[country[0]]}$`, 'i')
    if (value?.toString()?.match(re)?.length > 0) {
      return true
    } else {
      return i18n.global.t('form.wrongZipCode')
    }
  } else if (country[0] === null) {
    return i18n.global.t('form.wrongZipCode')
  }
  return true
})
